module.exports = __webpack_public_path__ + "img/customer.89e6e85c.svg";